/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 16/05/2025 17:41
 *
 */

import { MenuItem } from '@infodata-group/inf-commons';
import { SerializedVigiMenuItemInterface } from '../interface/serialized/serialized-vigi-menu-item.interface';
import { CrudAuthorization } from '../modules/shared/model/generic-page/crud-authorization';
import { Layout } from '../modules/shared/model/generic-page/layout';
import { VigiMenuItemNode } from '../page/page-admin-menu/model/vigi-menu-item-node';

export class VigiMenuItem extends MenuItem {
  public CRUD = new CrudAuthorization();
  public layout = new Layout('');
  public customRoute: string;
  // @ts-expect-error: Property 'submenus' is missing in type 'VigiMenuItem'
  public override submenus: VigiMenuItem[] = [];
  public parentId: string;

  constructor(id: string, label: string, icon: string, route?: string) {
    super(id, label, icon, '');
    if (
      route &&
      route[0] !== '/' &&
      !(route.includes('http') || route.includes('https'))
    ) {
      route = `/${route}`;
    }
    this.customRoute = route;
  }

  public get isExternalLink(): boolean {
    return (
      this.customRoute.search('http') > -1 ||
      this.customRoute.search('https') > -1
    );
  }

  public serialize(): SerializedVigiMenuItemInterface {
    let data = {
      id: this.id,
      label: this.label,
      icon: this.icon,
      route: this.customRoute ? this.customRoute : null,
      layout: this.layout.serialize(),
      disabled: !!this.disabled,
      childrens: this.submenus.map((x) => x.serialize()),
    };

    // If any info of CRUD => serialized it
    if (this.CRUD.serialize()) {
      data = { ...data, ...this.CRUD.serialize() };
    }
    return data;
  }

  public toVigiMenuItemNode(node?: VigiMenuItemNode): VigiMenuItemNode {
    const itemNode = new VigiMenuItemNode(this);
    if (this.hasSubMenus()) {
      // Recursive call
      this.submenus.map((x) => x.toVigiMenuItemNode(itemNode));
    }
    if (node) {
      node.nodes.push(itemNode);
    }
    return itemNode;
  }

  /**
   * Check if matching in objet & submenu
   * Retur both in case of child matching
   * @param value: string
   * @param key: string
   */
  public isMatching(value: string, key: string): VigiMenuItem[] {
    // Todo :: Recursive call ?
    if (this[key] === value) {
      return [this];
    }
    for (const subItem of this.submenus) {
      if (subItem[key] === value) {
        return [this, subItem];
      }

      const submenu = subItem.submenus.find((x) => x[key] === value);
      if (submenu) {
        return [this, subItem, submenu];
      }
    }
    return [];
  }

  public unselectAndClose(): void {
    this.isSelected = false;
    this.isOpen = false;
    this.submenus.forEach((subItem) => subItem.unselectAndClose());
  }
}
